import { useEffect, useState } from "react";
import scrollToTopIcon from "../../assets/scrollToTopIcon.svg";
const ScrollToTop = () => {
  const [showButton, setShowButton] = useState(false);
  useEffect(() => {
    // Function to show or hide the scroll-to-top button based on scroll position
    const handleScroll = () => {
      if (window.scrollY > window.innerHeight / 2) {
        setShowButton(true);
      } else {
        setShowButton(false);
      }
    };

    // Add scroll event listener when component mounts
    window.addEventListener("scroll", handleScroll);

    // Remove scroll event listener when component unmounts
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <button
      onClick={scrollToTop}
      className={`fixed bottom-0 right-0 z-50 m-8 rounded-full border border-primaryColor bg-white p-4  shadow-xl  ${
        !showButton && "hidden"
      }`}
      title="Scroll to top"
    >
      <img className="h-8 w-8" src={scrollToTopIcon} alt="" />
    </button>
  );
};

export default ScrollToTop;
